import React from "react";
import { ToastContainer } from "react-toastify";
import { Card } from "@opendate-app/setlist";

import AhoyMessageShow from "./AhoyMessageShow";

const AhoyMessageShowContainer = (props) => (
  <>
    <ToastContainer icon={false} />
    <Card>
      <AhoyMessageShow {...props} />
    </Card>
  </>
);

export default AhoyMessageShowContainer;
